<h1 mat-dialog-title>Extra Quantity</h1>

<div mat-dialog-content>Choose import mode</div>

<div mat-dialog-actions>
  <button class="btn-product" [mat-dialog-close]="'incremental'" style="margin-right: 10px; margin-left: 10px;">Incremental extra quantity</button>
  <button class="btn-product" [mat-dialog-close]="'total'" style="margin-right: 10px; margin-left: 10px;">Total extra quantity</button>
</div>
